module.exports = __webpack_public_path__ + "img/IMG-20200227-WA0332.ffd09fb8.jpg";